"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderWarning = exports.OrderServiceLevel = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["CREATED"] = "CREATED";
    OrderStatus["ERROR"] = "ERROR";
    OrderStatus["SHIPPED"] = "SHIPPED";
    OrderStatus["DELIVERED"] = "DELIVERED";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["ON_HOLD"] = "ON_HOLD";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderServiceLevel;
(function (OrderServiceLevel) {
    OrderServiceLevel["PRIORITY_1_DAY"] = "PRIORITY_1_DAY";
    OrderServiceLevel["PRIORITY_2_DAY"] = "PRIORITY_2_DAY";
    OrderServiceLevel["PRIORITY_3_DAY"] = "PRIORITY_3_DAY";
    OrderServiceLevel["FLEXPEDITED"] = "FLEXPEDITED";
    OrderServiceLevel["STANDARD"] = "STANDARD";
    OrderServiceLevel["NOT_SET"] = "NOT_SET";
    OrderServiceLevel["WORLDWIDE_STANDARD_DDP"] = "WORLDWIDE_STANDARD_DDP";
})(OrderServiceLevel = exports.OrderServiceLevel || (exports.OrderServiceLevel = {}));
var OrderWarning;
(function (OrderWarning) {
    OrderWarning["ALLOWLISTED_ADDRESS"] = "ALLOWLISTED_ADDRESS";
    OrderWarning["BAD_ADDRESS"] = "BAD_ADDRESS";
    OrderWarning["CORRECTED_PROMISED_DELIVERY_TIME"] = "CORRECTED_PROMISED_DELIVERY_TIME";
    OrderWarning["EBAY_UNDETERMINED_FAST_TAG"] = "EBAY_UNDETERMINED_FAST_TAG";
    OrderWarning["FAST_SHIPPING_EXEMPT"] = "FAST_SHIPPING_EXEMPT";
    OrderWarning["FORCED_ADDRESS"] = "FORCED_ADDRESS";
    OrderWarning["GMAPS_CORRECTED_ADDRESS"] = "GMAPS_CORRECTED_ADDRESS";
    OrderWarning["GOOGLE_UNDETERMINED_FAST_TAG"] = "GOOGLE_UNDETERMINED_FAST_TAG";
    OrderWarning["INVENTORY_UNAVAILABLE"] = "INVENTORY_UNAVAILABLE";
    OrderWarning["LATE_INGESTION"] = "LATE_INGESTION";
    OrderWarning["LARGE_ADDRESS_CORRECTION"] = "LARGE_ADDRESS_CORRECTION";
    OrderWarning["NO_SLA"] = "NO_SLA";
    OrderWarning["ORDER_COST_NOT_SET"] = "ORDER_COST_NOT_SET";
    OrderWarning["ORDER_ON_HOLD"] = "ORDER_ON_HOLD";
    OrderWarning["REPROCESSED_ORDER"] = "REPROCESSED_ORDER";
    OrderWarning["THIRD_PARTY_ADDRESS_VALIDATION_SKIPPED"] = "THIRD_PARTY_ADDRESS_VALIDATION_SKIPPED";
    OrderWarning["USING_RESERVATIONS"] = "USING_RESERVATIONS";
    OrderWarning["WALMART_UNDETERMINED_FAST_TAG"] = "WALMART_UNDETERMINED_FAST_TAG";
    OrderWarning["WEBSITE_UNDETERMINED_FAST_TAG"] = "WEBSITE_UNDETERMINED_FAST_TAG";
    // Description of order operations: https://deliverr.atlassian.net/wiki/spaces/EN/pages/245104668/Order+Operations
    OrderWarning["ORDER_OPERATION_1"] = "ORDER_OPERATION_1";
    OrderWarning["ORDER_OPERATION_2"] = "ORDER_OPERATION_2";
})(OrderWarning = exports.OrderWarning || (exports.OrderWarning = {}));
//# sourceMappingURL=DeliverrOrder.js.map